"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DealPlacementsToJSON = exports.DealPlacementsFromJSONTyped = exports.DealPlacementsFromJSON = exports.DealPlacements = void 0;
/**
 * Deal placements are a subset of AdSet Placements.
 * @export
 */
exports.DealPlacements = {
    Music: 'MUSIC',
    Podcast: 'PODCAST'
};
function DealPlacementsFromJSON(json) {
    return DealPlacementsFromJSONTyped(json, false);
}
exports.DealPlacementsFromJSON = DealPlacementsFromJSON;
function DealPlacementsFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.DealPlacementsFromJSONTyped = DealPlacementsFromJSONTyped;
function DealPlacementsToJSON(value) {
    return value;
}
exports.DealPlacementsToJSON = DealPlacementsToJSON;
